import { Api } from 'utils';

class BankService {
	
	static admin = {
		get: async (params?: any) => Api.createResponse('admin/banks',params),
		getData: async (params?: any) => Api.createResponse('admin/banks/data',params),
		create: async (params?: any) => Api.createResponse('admin/banks/create',params),
		edit: async (params?: any) => Api.createResponse('admin/banks/edit',params),
		delete: async (params?: any) => Api.createResponse('admin/banks/delete',params),
		changeStatus: async (params?: any) => Api.createResponse('admin/banks/change-status',params),
		updatePaymentMethod: async (params?: any) => Api.createResponse('admin/banks/update-payment-method',params),
		getPaymentMethod: async (params?: any) => Api.createResponse('admin/banks/get-payment-method',params),
	}

}

export default BankService;